import validator from 'validator'

export const contactDetails = player => {
  const email = (player.emailAddress || '').trim()
  let phone = (player.cellPhone || '').replace(/[\s().-]/g, '')
  if (/^\d{10}$/.test(phone) && ['US', 'CA'].includes(player.countryCode || 'US')) phone = `+1${phone}`
  return {
    email: validator.isEmail(email) ? email : '',
    sms: /^\+?\d{7,15}$/.test(phone) ? phone : '',
  }
}

export const contactUrl = ({ channel, recipient, subject, message, apple = false }) => {
  if (!recipient || !message.trim() || (channel === 'email' && !subject.trim())) return ''
  if (channel === 'email') return `mailto:${encodeURIComponent(recipient)}?subject=${encodeURIComponent(subject.trim())}&body=${encodeURIComponent(message.trim())}`
  return `sms:${recipient}${apple ? '&' : '?'}body=${encodeURIComponent(message.trim())}`
}

export const contactMessage = (player, seasonName) => `Hi ${player.firstName || player.fullName || 'there'}, are you playing Redherrings Football${seasonName ? ` in ${seasonName}` : ' this year'}? We would love to have you back! Please let me know, or sign up at https://redherrings.com.`
